import React, { useCallback, useEffect, useState } from 'react';
import { fetchDashboard } from '../services/dashboardApi';

const menuItems = [
  ['overview', 'grid', 'Overview'],
  ['export', 'briefcase', 'Export Enquiries'],
  ['bin', 'trash', 'Export Bin'],
  ['mail-ids', 'mail', 'Mail IDs'],

];

const paths = {
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  briefcase: 'M9 6V4h6v2m-9 0h12a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm-2 5h10M10 11v2h4v-2',
trash: 'M3 6h18M8 6V4h8v2m2 0l-1 14H7L6 6m4 4v6m4-6v6',
  mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
  chevronDown: 'M6 9l6 6 6-6',
};

function Icon({ name }) {
  return <svg className="nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name]} /></svg>;
}

function Sidebar({ collapsed, active, onSelect }) {
  const [counts, setCounts] = useState({ export: 0, bin: 0 });
  const loadCounts = useCallback(() => {
    fetchDashboard().then(data => setCounts({
      export: data?.stats?.total || 0,
      bin: data?.stats?.bin || 0,
    })).catch(() => {});
  }, []);

  useEffect(() => { loadCounts(); }, [active, loadCounts]);
  useEffect(() => {
    window.addEventListener('enquiry-counts-changed', loadCounts);
    return () => window.removeEventListener('enquiry-counts-changed', loadCounts);
  }, [loadCounts]);

  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="sidebar-label">EXPORT INQUIRY</div>
      <nav aria-label="Export inquiry navigation">
        <ul>
          {menuItems.map(([key, icon, label]) => (
            <li key={key}>
              <button
                className={active === key ? 'active' : ''}
                onClick={() => onSelect(key)}
                title={collapsed ? label : undefined}
              >
                <Icon name={icon} />
                <span>{label}</span>
                {(key === 'export' || key === 'bin') && <em className={`sidebar-badge ${key}`} aria-label={`${counts[key]} ${label}`}>{counts[key] > 999 ? '999+' : counts[key]}</em>}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      {/* <div className="sidebar-help">
        <div className="help-icon">?</div>
        <div><strong>Need help?</strong><span>Visit support center</span></div>
      </div> */}
    </aside>
  );
}

export default Sidebar;
